import './preprocessLandscape';
import { useCallback, useRef } from 'react';
// import { useFrame } from '@react-three/fiber';
import Orb from './Orb';
import Eclipse from './Eclipse';
import { useAsset } from '@artica/assets';
import { useManagedAnimations } from '@artica/hooks';
import { parallax } from '@immutabl3/alchemy/three';

export default function Contents() {
  const asset = useAsset('landscape');
  const groupRef = useRef();

  const {
    animations,
    nodes: nodesLandscape,
    materials: materialsLandscape,
  } = asset;
  const { actions } = useManagedAnimations(animations, groupRef);

  const onPercChange = useCallback(perc => {
    const animation = actions?.animation_0;
    if (!animation) return;
    const mixer = animation.getMixer();
    const { duration } = animation.getClip();
    const sec = duration * perc;
    mixer.setTime(sec);
  }, [actions]);

  // NOTE: this ticking doesn't appear to do anything, disabling for now
  // useFrame(({ clock }) => {
  //   for (const key in materialsLandscape) {
  //     materialsLandscape[key]?.onFogTick?.(clock);
  //   }
  // });

  return (
    <parallax.group
      ref={ groupRef }
      beaker="chapter1"
      onPercChange={ onPercChange }
    >
      <Orb />
      <Eclipse
        nodes={ nodesLandscape }
        materials={ materialsLandscape }
        fogNearColor={ [0.20, 0.23, 0.27] }
        fogHorizonColor={ [0.14, 0.18, 0.22] }
        fogNoiseSpeed={ 100 }
        fogNoiseFreq={ 0.092 }
        fogNoiseImpact={ 0 }
        fogCeiling={ 10000.00001 }
        fogFloor={ 10000.00001 }
      />
      <mesh name="landscape_FG">
        <primitive
          attach="geometry"
          object={ nodesLandscape.landscape_FG.geometry }
        />
        <primitive
          object={ materialsLandscape.Landscape_FG }
          attach="material"
        />
      </mesh>
      <mesh
        name="landscape_figure"
        position={ [0.39, -3.29, 3] }
      >
        <primitive
          attach="geometry"
          object={ nodesLandscape.landscape_figure.geometry }
        />
        <primitive
          object={ materialsLandscape.Landscape_Figure }
          attach="material"
        />
        <mesh
          name="Woman_Figure_reduced"
          position={ [-2.84, 8.81, -15.08] }
          rotation={ [-Math.PI, 0, -Math.PI] }
          scale={ 0.01 }
        >
          <primitive
            attach="geometry"
            object={ nodesLandscape.Woman_Figure_reduced.geometry }
          />
          <primitive
            object={ materialsLandscape.M_Woman_Winter_2 }
            attach="material"
          />
        </mesh>
        <mesh
          name="Rock"
          position={ [-3.08, 7.91, -15.58] }
          rotation={ [-1.29, 0.4, 0.52] }
          scale={ [0.1, 0.2, 0.1] }
        >
          <primitive
            attach="geometry"
            object={ nodesLandscape.Rock.geometry }
          />
          <primitive
            attach="material"
            object={ materialsLandscape.Icelandic_Rock_tfiqaftda }
          />
        </mesh>
      </mesh>
      <mesh
        name="SC01_landscape_SNOW"
        position={ [-161.91, 33.24, -326.91] }
      >
        <primitive
          attach="geometry"
          object={ nodesLandscape.SC01_landscape_SNOW.geometry }
        />
        <primitive
          attach="material"
          object={ materialsLandscape.land_snow }
        />
      </mesh>
      <mesh
        name="SC01_landscape_ROCK"
        position={ [-161.91, 33.24, -326.91] }
      >
        <primitive
          attach="geometry"
          object={ nodesLandscape.SC01_landscape_ROCK.geometry }
        />
        <primitive
          object={ materialsLandscape.land_rocky }
          attach="material"
        />
      </mesh>
    </parallax.group>
  );
};